import React from "react";

import Slide from "react-reveal/Slide";
import Flip from "react-reveal/Flip";

import image1 from "../assets/quote2.jpg";

export default function Quote2() {
  return (
    <>
      <Flip left cascade>
        <div
          className="container-content"
          style={{
            borderRadius: "80px 10px 80px 10px",
            padding: "40px 25px 80px 25px",
            zIndex: 1,
          }}
        >
          <i className="fas fa-feather-alt"></i>
          <p
            className="garamond-font"
            style={{
              fontSize: 18,
              color: "black",
              marginTop: 10,
              fontWeight: "inherit",
            }}
          >
            ~ Restless flycatcher ~
          </p>
          <p
            className="garamond-font"
            style={{ fontSize: 16, color: "black", marginTop: 10 }}
          >
            Our minds follow well behind <br />
            the old magic of our souls <br />
            that knows it's in love <br />
            from the first moment <br />
            we see them.
          </p>
        </div>
      </Flip>
      <Slide bottom>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "-85px",
            zIndex: "-1",
          }}
        >
          <div style={{ width: "75%" }}>
            <img
              src={image1}
              className="quote-image"
              objectfit="cover"
              width="100%"
              height="100%"
              style={{ borderRadius: "10px", zIndex: "-1" }}
            />
          </div>
        </div>
      </Slide>
    </>
  );
}
